module.exports = __webpack_public_path__ + "media/images/emblems/Eschert-coat_of_arms-2cec102d2b48ea089b9f44145c6b75a7.svg";